import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { FormSubtitle } from 'app/components/Core';
import { InputField } from 'app/components/Core/ChakraInputField/InputField';
import { ChakraAutocompleteField } from 'app/components/Core/ChakraAutocompleteField/ChakraAutocompleteField';
import { useIsMobile } from 'app/utils/hooks';
import { Option } from 'types/general.types';
import { ProfileFormData } from '../ProfileForm/types';

interface ProfileContactSectionProps {
  countries: Option[];
}

export const ProfileContactSection: React.FC<ProfileContactSectionProps> = ({
  countries,
}) => {
  const {
    formState: { errors },
    control,
    register,
  } = useFormContext<ProfileFormData>();

  const isMobile = useIsMobile();
  const templateColumns = isMobile ? '1fr' : 'repeat(3, 1fr)';
  const colSpan = isMobile ? 3 : 'auto';

  return (
    <Grid templateColumns={templateColumns} gap={4}>
      <GridItem colStart={1} colSpan={colSpan}>
        <FormSubtitle>Location</FormSubtitle>
      </GridItem>
      <GridItem colStart={1} colSpan={colSpan}>
        <InputField
          label="Street Address"
          data-testid="primaryAddress"
          {...register('address.primaryAddress')}
          isInvalid={Boolean(errors.address?.primaryAddress)}
          errorMessage={errors.address?.primaryAddress?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <InputField
          label="Street Address 2"
          data-testid="secondaryAddress"
          {...register('address.secondaryAddress')}
          isInvalid={Boolean(errors.address?.secondaryAddress)}
          errorMessage={errors.address?.secondaryAddress?.message}
        />
      </GridItem>
      <GridItem colStart={1} colSpan={colSpan}>
        <InputField
          label="Zip code"
          data-testid="zipCode"
          {...register('address.zipCode')}
          isInvalid={Boolean(errors.address?.zipCode)}
          errorMessage={errors.address?.zipCode?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <InputField
          label="City"
          data-testid="city"
          {...register('address.city')}
          isInvalid={Boolean(errors.address?.city)}
          errorMessage={errors.address?.city?.message}
        />
      </GridItem>
      <GridItem colStart={1} colSpan={colSpan}>
        <InputField
          label="State"
          data-testid="state"
          {...register('address.stateProvinceRegion')}
          isInvalid={Boolean(errors.address?.stateProvinceRegion)}
          errorMessage={errors.address?.stateProvinceRegion?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <ChakraAutocompleteField
          dataTestId="country"
          control={control}
          isInvalid={Boolean(errors?.country)}
          errorMessage={errors?.country?.message}
          name="country"
          label="Country"
          options={countries}
          isClearable
        />
      </GridItem>
    </Grid>
  );
};
